import { render, staticRenderFns } from "./InqMember.vue?vue&type=template&id=bdb778d8&scoped=true&"
import script from "./InqMember.vue?vue&type=script&lang=js&"
export * from "./InqMember.vue?vue&type=script&lang=js&"
import style0 from "./InqMember.vue?vue&type=style&index=0&id=bdb778d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb778d8",
  null
  
)

component.options.__file = "InqMember.vue"
export default component.exports